import { useState, useEffect } from "react";
import { getAllMedia } from "../../../api/apiServices";
import MediaUpload from "./components/MediaUpload";
import MediaGallery from "./components/MediaGallery";

export default function MediaManager() {
  const [mediaData, setMediaData] = useState([]);

  const fetchMediaList = async () => {
  try {
    const res = await getAllMedia();
    setMediaData(res.media); // ✅ Store only the array
  } catch (err) {
    console.error(err);
  }
};

  useEffect(() => {
    fetchMediaList();
  }, []);

  return (
    <div className="min-h-screen bg-slate-50 p-8">
      <h1 className="text-3xl font-bold text-slate-800 mb-8">Media Manager</h1>

      <MediaUpload onUploadSuccess={fetchMediaList} />
      <MediaGallery mediaList={mediaData} onMediaDeleted={fetchMediaList} />
    </div>
  );
}
